import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import RefreshIcon from "@material-ui/icons/Refresh";

import AdminWrapper from "../../containers/AdminWrapper";
import ContentWrapper from "../../containers/ContentWrapper";

import moment from "moment";

//constants
import * as shootTypes from "../../redux/constants/ShootsActionTypes";

//actions
import * as shootActions from "../../redux/actions/shootsactions";
import * as dialogActions from "../../redux/actions/dialogactions";

//Components
// import ConfirmationDialog from '../Dialogs/ConfirmationDialog';

//Services
import shootService from "../../services/shootService";

class ShootsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      failed: false,
      data: [],
      open: false,
      selectedMenu: null,
      selectedRow: null,
      selectedShoot: {},
      value: 0,
      alertStatus: false,
      orderBy: "clinic",
      order: "asc",
      filterstate: ""
    };

    this.handleCloseMenu = this.handleCloseMenu.bind(this);
  }

  async componentDidMount() {
    this.getShoots();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.confirmDialog === false && prevProps.confirmDialog === true) {
      this.handleCloseMenu();
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case shootTypes.SHOOTS_DELETE_SHOOT:
            //do delete actions here
            try {
              this.setState({ fetching: true });
              const { clinic, created_at } = this.state.selectedShoot;
              await shootService.deleteShoot({
                clinic,
                created_at
              });
              this.getShoots();
            } catch (err) {
              console.log("deletion failed", err);
            }
            break;
          case shootTypes.SHOOTS_START:
            try {
              this.setState({ fetching: true });
              const { selectedShoot } = this.state;
              const { clinic, created_at } = selectedShoot;
              let { data } = await shootService.getOneShoot(
                {
                  clinic,
                  created_at
                },
                {
                  params: {
                    type: "details"
                  }
                }
              );
              let { photo, video } = data;
              if (photo > 0 || video > 0) {
                await shootService.updateShoot(
                  {
                    clinic: selectedShoot.clinic,
                    created_at: selectedShoot.created_at
                  },
                  {
                    address: selectedShoot.address,
                    date: selectedShoot.date,
                    status: "PENDING"
                  }
                );
                this.getShoots();
              } else {
                this.setState({ alertStatus: true });
                this.setState({ fetching: false });
              }
            } catch (err) {
              console.log("update failed: " + err);
            }
            break;
          default:
            break;
        }
      }
      console.log(this.props.confirmAction);
    }
  }

  getShoots = async () => {
    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let { data } = await shootService.getShoots();
      console.log(data);
      this.setState({ data, fetching: false, failed: false });
    } catch (err) {
      console.log(err);
      this.setState({ fetching: false, failed: true });
    }
  };

  handleMenu = (e, selectedShoot) => {
    console.log(selectedShoot);
    this.setState({ selectedMenu: e.currentTarget, open: true, selectedShoot });
  };

  handleCloseMenu = () => {
    this.setState({ selectedMenu: null, open: false });
  };

  onAddPhotoShot = () => {
    console.log(this.state.selectedShoot);
    this.props.history.push(`/shoots/add/${this.state.selectedShoot.clinic}/${this.state.selectedShoot.created_at}/photo-shots?type=photo`);
    this.setState({ selectedRow: null });
  };

  onAddVideoShot = () => {
    this.props.history.push(`/shoots/add/${this.state.selectedShoot.clinic}/${this.state.selectedShoot.created_at}/video-shots?type=video`);
    this.setState({ selectedRow: null });
  };
  onAddQuestion = () => {
    this.props.history.push(`/shoots/add/${this.state.selectedShoot.clinic}/${this.state.selectedShoot.created_at}/add-question`);
    this.setState({ selectedRow: null });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  onEdit = () => {
    let { clinic, created_at } = this.state.selectedShoot;
    this.props.history.push(`/shoots/edit/${clinic}/${created_at}`);
  };

  onDelete = () => {
    this.setState({
      open: false
    });
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to delete this shoot. Please confirm if you want to do this action.",
      shootTypes.SHOOTS_DELETE_SHOOT
    );
  };

  onSendShootToCompany = () => {
    this.setState({
      open: false
    });
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to send/start this shoot to the contractors. Please confirm if you want to do this action.",
      shootTypes.SHOOTS_START
    );
  };

  goToCreateShoot = () => this.props.history.push("/shoots/create");

  viewShoot = shoot => {
    // console.log(shoot);
    // if (shoot.status === "CHECKING")
    //   this.props.history.push(
    //     `/shoots/check/${shoot.clinic}/${shoot.created_at}`
    //   );
    // else
    this.props.history.push(`/shoots/view/${shoot.clinic}/${shoot.created_at}`);
  };

  createSortHandler = property => {
    console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };
  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };
  desc = (a, b, orderBy) => {
    if (b[orderBy].toUpperCase() < a[orderBy].toUpperCase()) {
      return -1;
    }
    if (b[orderBy].toUpperCase() > a[orderBy].toUpperCase()) {
      return 1;
    }
    return 0;
  };
  handleChangeFilter = e => {
    console.log("filter", e.target.value);
    this.setState({
      filterstate: e.target.value
    });
  };

  render() {
    const open = this.state.open;
    const { order, orderBy, data, filterstate } = this.state;

    const headRows = [
      { id: "clinic", numeric: false, disablePadding: false, label: "Clinic Name" },
      { id: "address", numeric: false, disablePadding: false, label: "Address" },
      { id: "date", numeric: false, disablePadding: false, label: "Shoot Date" },
      { id: "", numeric: false, disablePadding: false, label: "Company" },
      { id: "", numeric: false, disablePadding: false, label: "Status" },
      { id: "", numeric: false, disablePadding: false, label: "Action" }
    ];
    const sortData = [];
    data.map(e => {
      if (e.date > new Date().getTime() && e.status === "DRAFT") {
        e.status = "ON SCHEDULE";
      } else if (e.status === "PENDING") {
        e.status = "ONGOING";
      }
      sortData.push(e);
    });

    let queryData = this.stableSort(sortData, this.getSorting(order, orderBy));
    const sessionList = queryData
      .filter(e => e.status.includes(filterstate))
      .map((session, key) => {
        // console.log('session', session)
        const cellStyle = {
          display: "inline-block",
          position: "relative",
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        };
        return (
          <TableRow key={key}>
            <TableCell>
              <div style={cellStyle}>{session.clinic}</div>
            </TableCell>
            <TableCell>
              <div style={cellStyle}>{session.address}</div>
            </TableCell>
            <TableCell>
              <div style={cellStyle}>{moment(parseInt(session.date)).format("MMM D, YYYY hh:mm A")}</div>
            </TableCell>
            <TableCell>{session.company || "TBD"}</TableCell>
            <TableCell>{(session.date > new Date().getTime() && session.status === "DRAFT") ? "ON SCHEDULE" : session.status === "PENDING" ? "ONGOING" : session.status}</TableCell>
            <TableCell>
              <div>
                <IconButton
                  aria-label="More"
                  aria-owns={open ? "long-menu" : undefined}
                  aria-haspopup="true"
                  onClick={e => this.handleMenu(e, session)}
                >
                  <MoreVertIcon />
                </IconButton>
              </div>
            </TableCell>
          </TableRow>
        );
      });

    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Shoots" hasPadding={true}>
          <Toolbar variant="dense" style={{ padding: "10px 5px 20px" }} disableGutters={true}>
            <Typography variant="body2" color="textSecondary">
              Total Records: <b>{this.state.data.length}</b>
            </Typography>
            <div style={{ flexGrow: 1 }} />
            <Typography variant="body2" style={{ marginRight: 8 }} color="textSecondary">
              Filter Status:
            </Typography>
            <FormControl variant="outlined" style={{ marginRight: 10 }}>
              <Select
                value={filterstate}
                onChange={this.handleChangeFilter}
                displayEmpty={true}
                input={<OutlinedInput name="filter" margin="dense" placeholder="Filter" labelWidth={0} />}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="DRAFT">DRAFT</MenuItem>
                <MenuItem value="ON SCHEDULE">ON SCHEDULE</MenuItem>
                <MenuItem value="PENDING">PENDING</MenuItem>
                <MenuItem value="ONGOING">ONGOING</MenuItem>
                <MenuItem value="COMPLETED">COMPLETED</MenuItem>
              </Select>
            </FormControl>
            <Divider style={{ margin: "0 10px", height: 40, width: 2 }} />
            <div>
              <Tooltip title="Refresh List">
                <IconButton onClick={this.getShoots} aria-label="Refresh">
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add Shoot">
                <Fab
                  onClick={this.goToCreateShoot}
                  size="small"
                  color="primary"
                  aria-label="Add"
                  style={{
                    marginLeft: "5px",
                    boxShadow: "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)"
                  }}
                >
                  <AddIcon />
                </Fab>
              </Tooltip>
            </div>
          </Toolbar>
          {this.state.alertStatus && (
            <Paper
              style={{
                padding: 24,
                backgroundColor: "#e74c3c",
                margin: "24px 0",
                position: "relative"
              }}
              elevation={1}
            >
              <CloseIcon
                style={{
                  color: "#fff",
                  position: "absolute",
                  right: 24,
                  top: 24,
                  cursor: "pointer"
                }}
                onClick={() => this.setState({ alertStatus: false })}
              />
              <Typography variant="h6" style={{ color: "#fff", fontWeight: "bold" }}>
                Oooppss!! I'm sorry! You can't do that!
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#fff", fontWeight: "bold", padding: "0 24px" }}>
                You need to add shots before you can schedule shoot to the client!
              </Typography>
            </Paper>
          )}
          <Paper style={{ width: "100%", overflowX: "auto" }}>
            {this.state.fetching ? <LinearProgress color="primary" style={{ height: 2 }} /> : null}
            {this.state.failed ? (
              <div style={{ padding: "20px 0", textAlign: "center" }}>
                <Typography variant="h3" gutterBottom style={{ color: "rgba(0,0,0,0.5)" }}>
                  Something went wrong...
                </Typography>
                <Button variant="outlined" color="primary" onClick={this.getShoots}>
                  Reload
                </Button>
              </div>
            ) : (
              <Table style={{ minWidth: 1175 }}>
                <TableHead>
                  <TableRow>
                    {headRows.map((row, key) => (
                      <TableCell
                        key={key}
                        align={row.numeric ? "right" : "left"}
                        padding={row.disablePadding ? "none" : "default"}
                        sortDirection={orderBy === row.id ? order : false}
                        onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                        style={row.id == "" ? null : { cursor: "pointer" }}
                      >
                        {this.state.orderBy === row.id ? (
                          <TableSortLabel active={orderBy === row.id} direction={order}>
                            {row.label}
                          </TableSortLabel>
                        ) : (
                          row.label
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {sessionList.length === 0 && !this.state.fetching ? (
                  <TableBody>
                    <TableCell colSpan={6}>
                      <Typography color="textSecondary" variant="h6" style={{ width: "100%", textAlign: "center", padding: "50px 0" }}>
                        No data to be displayed
                      </Typography>
                    </TableCell>
                  </TableBody>
                ) : (
                  <TableBody>{sessionList}</TableBody>
                )}
              </Table>
            )}
          </Paper>
          <Menu
            id="long-menu"
            anchorEl={this.state.selectedMenu}
            open={open}
            onClose={this.handleCloseMenu}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            PaperProps={{
              elevation: 1
            }}
          >
            {(this.state.selectedShoot.status === "DRAFT" || this.state.selectedShoot.status === "ON SCHEDULE") && [
              <MenuItem onClick={() => this.viewShoot(this.state.selectedShoot)} key="view">
                View shoot
              </MenuItem>,
              <MenuItem onClick={this.onAddPhotoShot} key="add photo">
                Add Photo Shots
              </MenuItem>,
              <MenuItem onClick={this.onAddVideoShot} key="add video">
                Add Video Shots
              </MenuItem>,
              <MenuItem onClick={this.onAddQuestion} key="add question">
                Add Questions
              </MenuItem>,
              <MenuItem onClick={this.onEdit} key="edit">
                Edit
              </MenuItem>,
              <MenuItem onClick={this.onDelete} key="delete">
                Delete
              </MenuItem>,
              <MenuItem onClick={this.onSendShootToCompany} key="start shoot">
                Start shoot
              </MenuItem>
            ]}
            {this.state.selectedShoot.status === "ONGOING" || this.state.selectedShoot.status === "COMPLETED" ? (
              <MenuItem onClick={() => this.viewShoot(this.state.selectedShoot)} key="view">
                View shoot
              </MenuItem>
            ) : null}
            {this.state.selectedShoot.status === "CHECKING"
              ? [
                  <MenuItem key="complete">Mark Complete</MenuItem>,
                  <MenuItem onClick={() => this.viewShoot(this.state.selectedShoot)} key="view">
                    View shoot
                  </MenuItem>
                ]
              : null}
          </Menu>
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch),
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShootsTab);
